module.exports = __webpack_public_path__ + "static/forbidden-treasure-28b327c30a6397f6f6139a82728b2ffd.png";